export const serialize = (filters = {}) =>
    Object.keys(filters).length ? encodeURIComponent(JSON.stringify(filters)) : '';

export const deserialize = (filterString) =>
    !filterString ? {} : JSON.parse(decodeURIComponent(filterString));
